{
  "global": {
    "signedUp": "tilmeldt",
    "signedUpPlural": "tilmeldte",
    "signUp": "Tilmeld",
    "optOut": "Afmeld",
    "youAreSignedUp": "Du er nu tilmeldt",
    "youOptedOut": "Du er nu afmeldt",
    "youAreLoggedIn": "Du er nu logget ind",
    "logOut": "Log af",
    "signingUp": "tilmelde dig",
    "optingOut": "afmelde dig",
    "today": "I dag",
    "dateDisplayAbbr": "d.",
    "timeOfDayAbbr": "kl.",
    "now": "Nu",
    "showToday": "Vis i dag",
    "showAll": "Vis alle",
    "showProfile": "Vis profil",
    "choose": "Vælg",
    "startDate": "Start dato",
    "startTime": "Start tid",
    "starts": "Starter",
    "started": "I gang nu",
    "startedAlready": "Startede",
    "cancelled": "Aflyst",
    "duration": "Varighed",
    "endTime": "Slut tid",
    "endDate": "Slut dato",
    "timeTo": "Om",
    "day": "dag",
    "days": "dage",
    "hour": "time",
    "hours": "timer",
    "hoursAbbr": "t.",
    "minutes": "min.",
    "tomorrow": "i morgen",
    "location": "lokation",
    "document": "dokument",
    "documents": "Dokumenter",
    "images": "Billeder",
    "imagesAndVideos": "Billeder og videoer",
    "additionalProfiles": "flere",
    "passedDeadline": "Lukket for til- og afmeld",
    "close": "Luk",
    "completed": "Udført",
    "fromDate": "Fra",
    "toDate": "Til",
    "date": "Dato",
    "oclock": "Klokken",
    "week": "Uge",
    "thisWeek": "Denne uge",
    "goToThisWeek": "Gå til denne uge",
    "goToToday": "Gå til i dag",
    "all": "alle",
    "seeAll": "se alle",
    "remaining": "De resterende",
    "participate": "deltager",
    "participantsPlural": "deltager | deltagere",
    "participants": "Deltagere",
    "responsible": "Ansvarlige",
    "responsiblePlural": "ansvarlig | ansvarlige",
    "signUpDeadline": "Til/afmeldingsfrist om",
    "signUpExpired": "Til/afmeldingsfrist udløbet",
    "maxSignupsReached": "Ingen pladser tilbage",
    "readMore": "Læs mere",
    "genitive": "s",
    "nothingToShow": "Der er intet at vise",
    "waitingForResponse": "Venter på svar...",
    "tts": "læs op",
    "startButton": "start",
    "backButton": "Tilbage",
    "backTo": "Tilbage til",
    "errorOccured": "Der er sket en fejl. Prøv igen...",
    "weekdayMonday": "Mandag",
    "weekdayTuesday": "Tirsdag",
    "weekdayWednesday": "Onsdag",
    "weekdayThursday": "Torsdag",
    "weekdayFriday": "Fredag",
    "weekdaySaturday": "Lørdag",
    "weekdaySunday": "Søndag",
    "weekdayMondayAbbr": "Man",
    "weekdayTuesdayAbbr": "Tir",
    "weekdayWednesdayAbbr": "Ons",
    "weekdayThursdayAbbr": "Tor",
    "weekdayFridayAbbr": "Fre",
    "weekdaySaturdaydayAbbr": "Lør",
    "weekdaySunddayAbbr": "Søn",
    "MONDAY": "Mandag",
    "TUESDAY": "Tirsdag",
    "WEDNESDAY": "Onsdag",
    "THURSDAY": "Torsdag",
    "FRIDAY": "Fredag",
    "SATURDAY": "Lørdag",
    "SUNDAY": "Søndag",
    "autoplay": "Autoplay",
    "stop": "Stop",
    "play": "Afspil",
    "pause": "Pause",
    "restart": "Genstart",
    "cancel": "Annuller",
    "description": "Beskrivelse",
    "error": "Fejl",
    "tryAgain": "Prøv igen",
    "obs": "Obs",
    "somethingWentWrong": "Noget gik galt",
    "nightShift": "Nattevagt",
    "backToNow": "Tilbage til nu",
    "switchUser": "Skift bruger",
    "noDescription": "Ingen beskrivelse",
    "about": "cirka",
    "busy": "Optaget",
    "departments": "Afdelinger",
    "dishes": "Delretter",
    "employee": "Medarbejder",
    "ends": "Slutter",
    "enterPinToAccess": "Skriv din kode for at få adgang",
    "error_suggestion": "Prøv venligst igen",
    "galleries": "Gallerier",
    "info": "Info",
    "institution": "Institution",
    "lastUpdateMinutes": "Opdateret {n} min. siden",
    "loading": "Tænker ...",
    "pictograms": "Piktogrammer",
    "repeats": "Gentages",
    "reset": "Nulstil",
    "resident": "Borger",
    "selectDepartment": "Vælg afdeling",
    "signupNotNeeded": "Tilmelding ikke nødvendig",
    "sort": "Sorter visning",
    "stopAutoplay": "Stop autoplay",
    "title": "Titel",
    "uncategorized": "ukategoriseret",
    "use": "Anvend",
    "videos": "Videoer"
  },
  "moduleNames": {
    "ACTIVITIES": "Aktiviteter",
    "BOOKING": "Booking",
    "EXTERNAL_ACTIVITIES": "Eksterne Aktiviteter",
    "GALLERY": "Galleri",
    "JOURNEY_PLANNER": "Rejseplan",
    "MEAL_PLAN": "Madplan",
    "MEETINGS": "Møder",
    "NEWS": "Nyheder",
    "OUR_HOME": "Hos Os",
    "SIMPLE_WORK_SCHEDULE": "Tjenesteplan",
    "WAYFINDER": "Wayfinder",
    "WEATHER": "Vejret",
    "WORK_SCHEDULE": "Tjenesteplan",
    "CALENDAR": "Kalender",
    "BOOKING_ENTRY": "Booking",
    "BOOKING_RESOURCE_ENTRY": "Booking",
    "BOOKING_RESOURCES": "Booking"
  },
  "activities": {
    "moduleName": "Aktiviteter",
    "noActivities": "Ingen aktiviteter",
    "noActivitiesDescription": "Der er ingen aktiviteter at vise...",
    "noVacancy": "Ingen pladser tilbage",
    "vacation": "Ferier",
    "clubs": "Klubber",
    "noClubs": "Der er ingen klubber at vise...",
    "optedOut": "Du er nu afmeldt aktiviteten",
    "optOut": "Skriv din kode for at afmelde dig aktiviteten",
    "signedUp": "Du er nu tilmeldt aktiviteten",
    "signUp": "Skriv din kode for at tilmelde dig aktiviteten"
  },
  "externalActivities": {
    "moduleName": "Eksterne aktiviteter"
  },
  "activity": {
    "moduleName": "Aktivitet",
    "organizer": "Arrangeret af",
    "price": "Pris",
    "currencyAbbr": "kr.",
    "responsible": "ansvarlig",
    "responsiblePlural": "ansvarlige",
    "noSeatsLeft": "Ingen pladser tilbage",
    "oneSeatLeft": "plads tilbage",
    "moreSeatsLeft": "pladser tilbage",
    "theActivity": "aktiviteten",
    "alreadySignedOff": "Du er ikke tilmeldt dette aktivitet",
    "alreadySignedUp": "Du er allerede tilmeldt dette aktivitet"
  },
  "booking": {
    "moduleName": "Booking",
    "moduleHeaderOverview": "Booking-oversigt",
    "moduleHeaderResources": "Hvad vil du booke?",
    "noBookings": "Der er ikke oprettet nogle bookings",
    "noResources": "Der er ingen bookings at vise ...",
    "inUseNow": "I brug nu",
    "overview": "Oversigt",
    "newBooking": "Ny booking",
    "book": "book",
    "errorTimeSetting": "Fejl i tidsindstilling. Start dato/tid passerer slut dato/tid.",
    "ressourceNotAvailable": "Ressourcen er ikke ledig i valgte tidsrum. Prøv igen...",
    "ressourceNoLongerAvailable": "Ressourcen er ikke længere ledig. Prøv igen...",
    "chooseParticipants": "Vælg mindst en person, og tryk derefter på GEM",
    "bookingCreated": "Bookingen er oprettet",
    "bookingDeleted": "Bookingen er slettet",
    "deletingBooking": "slette bookingen",
    "returnToBooking": "Tilbage til booking",
    "action": "booke",
    "addDescription": "Tilføj en beskrivelse?",
    "selectParticipantsTitle": "Med hvem?",
    "selecttParticipantsDescription": "Vælg mindst en person, og tryk derefter på Gem",
    "toBook": "booke",
    "theBooking": "bookingen",
    "doubleBooking": "Hov, du er ved at foretage en dobbeltbooking.",
    "chooseDifferentTime": "Vælg venligst et andet tidspunkt for din booking.",
    "confirmBooking": "Bekræft booking",
    "allBookings": "Alle bookinger",
    "bookResource": "Skriv din kode for at booke",
    "cancelBooking": "Skriv din kode for at afmelde dig bookingen",
    "completed": "Bookingen er gennemført",
    "existingBookings": "Eksisterende bookinger",
    "noSchema": "Intet skema oprettet",
    "times": "Tider"
  },
  "documents": {
    "moduleName": "Dokumenter",
    "noDocuments": "Der er ingen dokumenter at vise..."
  },
  "employee": {
    "workingNow": "På arbejde nu!",
    "working": "På arbejde",
    "shift_conflict": "En medarbejder kan kun have én vagt om dagen pr. vagtplan."
  },
  "gallery": {
    "moduleName": "Galleri",
    "noGalleries": "Der er ingen gallerier at vise...",
    "galleryAccess": "få adgang til galleriet",
    "enterPinTitle": "Skriv din kode for at få adgang til galleriet"
  },
  "media": {
    "addToMy": {
      "pictures": "Tilføj til mine billeder",
      "videos": "Tilføj til mine videoer",
      "documents": "Tilføj til mine dokumenter"
    },
    "addedToMy": {
      "pictures": "Tilføjet til mine billeder",
      "videos": "Tilføjet til mine videoer",
      "documents": "Tilføjet til mine dokumenter"
    },
    "removeFromMy": {
      "pictures": "Fjern fra mine billeder",
      "videos": "Fjern fra mine videoer",
      "documents": "Fjern fra mine dokumenter"
    },
    "removedFromMy": {
      "pictures": "Fjernet fra mine billeder",
      "videos": "Fjernet fra mine videoer",
      "documents": "Fjernet fra mine dokumenter"
    },
    "noImages": "Ingen billeder",
    "noVideos": "Ingen videoer",
    "noDocuments": "Der er ingen dokumenter at vise ...",
    "myDocuments": "Mine dokumenter",
    "myGalleries": "Mine gallerier",
    "myImages": "Mine billeder",
    "myVideos": "Mine videoer"
  },
  "meals": {
    "moduleName": "Madplan",
    "eating": "spiser med",
    "noMenu": "har ikke nogen menu for",
    "noMenuDay": "Der er ikke oprettet menu for ",
    "theMeal": "måltidet",
    "noMeals": "Ingen måltider",
    "noMealsDescription": "Der er ingen måltider at vise ...",
    "alreadySignedUp": "Du er allerede tilmeldt dette måltid",
    "alreadySignedOff": "Du er ikke tilmeld dette måltid",
    "optedOut": "Du er nu afmeldt måltidet",
    "optOut": "Skriv din kode for at afmelde dig måltidet",
    "signedUp": "Du er nu tilmeldt måltidet",
    "signUp": "Skriv din kode for at tilmelde dig måltidet"
  },
  "meeting": {
    "agenda": "Dagsorden",
    "agendaPoints": "Dagsorden - Ét punkt | Dagsorden - {amount} punkter",
    "moduleName": "Møder",
    "daysLeft": "tilbage",
    "noAgenda": "Der er ingen punkter på dagsordenen...",
    "suggestionItems": "Ingen forslag | Ét forslag | {n} forslag",
    "suggestion": "Forslag",
    "suggestions": "Forslag til dagsorden",
    "moreSuggestions": "Forslag mere",
    "writeSuggestion": "Skriv forslag",
    "suggestionSaved": "Forslaget er nu gemt",
    "returnToMeeting": "Tilbage til mødet",
    "theMeeting": "mødet",
    "noMeetingsDescription": "Der er ingen møder at vise...",
    "alreadySignedUp": "Du er allerede tilmeldt dette møde",
    "toSuggest": "skrive et forslag til mødet",
    "agendaPointss": "Dagsorden - 1 ting",
    "agendaPointss_plural": "Dagsorden - {amount} ting",
    "alreadySignedOff": "Du er ikke tilmeld dette møde",
    "category": "Kategori",
    "noSuggestionsYet": "Ingen forslag endnu",
    "tts_agenda_point": "Punkt {number}: {title}",
    "tts_user_suggestion": "Forslag fra {user}: {suggestion}"
  },
  "modals": {
    "login": "Log ind",
    "loginText": "Vælg dig selv fra listen",
    "isSignedUp": "er tilmeldt",
    "allResidentsIn": "Alle borgere i",
    "allEmployeesIn": "Alle medarbejdere i",
    "save": "Gem",
    "delete": "slet",
    "wrongPassword": "Forkert kode, prøv venligst igen",
    "myPictures": "Billeder af mig",
    "myTags": "Disse billeder er jeg blevet tagget i.",
    "returnToPicture": "Tilbage til billede",
    "whoIsTagged": "Hvem er på billedet",
    "whoIsTaggedText": "Vælg de personer som er på billedet. Tryk derefter på GEM",
    "documentError": "Dokumentet kunne ikke hentes!",
    "writePassword": "Skriv din kode for at ",
    "writePasswordSuggestion": "skrive forslag til ",
    "writePasswordEdit": "redigere ",
    "writePasswordOptin": "tilmelde dig ",
    "writePasswordOptout": "afmelde dig ",
    "youAreBooking": "Du er ved at booke ",
    "ressourcePurpose": "Hvad skal ressourcen bruges til?",
    "searchResident": "Søg efter borger",
    "keyboardDelete": "SLET",
    "keyboardSpace": "Mellemrum",
    "logOn": "Log på",
    "next": "Næste",
    "skip": "Spring over",
    "writeYourSuggestion": "Skriv dit forslag",
    "emptyString": "tekst tom",
    "passwordLocked": "Adgangskoden er blevet låst af sikkerhedshensyn. Prøv igen om {amount}",
    "tooManyAttempts": "For mange forsøg. Adgangskoden er blevet låst af sikkerhedshensyn.",
    "tooManyAttemptsTryAgain": "Prøv igen om {minutes} min."
  },
  "news": {
    "moduleName": "Nyheder",
    "noNews": "Ingen nyheder",
    "noNewsDescription": "Der er ingen nyheder at vise...",
    "published": "Udgivet: "
  },
  "ourHome": {
    "moduleName": "Hos os",
    "videoPresentation": "Video præsentation",
    "presentation": "Præsentation",
    "noPresentation": "har ingen præsentation",
    "galleries": "Gallerier",
    "videos": "Videoer",
    "documents": "Dokumenter",
    "noDocuments": "Der er ingen dokumenter",
    "noResidents": "Ingen borgere i",
    "noEmployees": "Ingen medarbejdere i",
    "residents": "Borgere",
    "employees": "Medarbejdere",
    "noMeetings": "Der er ingen kommende møder...",
    "dayLeft": "dag tilbage",
    "daysLeft": "dage tilbage",
    "iAmTagged": "Disse billeder er jeg blevet tagget i"
  },
  "resident": {
    "homeDays": "Hjemmedage",
    "birthdayToday": "har fødselsdag i dag!",
    "myPictures": "Mine billeder",
    "noVideos": "Der er ingen videoer at vise...",
    "resident": "Borger"
  },
  "scheduleShift": {
    "moduleName": "Tjenesteplan",
    "noShifts": "Der er ikke oprettet nogen tjenester",
    "noShiftsToday": "Ingen på arbejde i dag",
    "options": "Du har tre muligheder",
    "cancel": "aflyse",
    "cancelShift": "aflyse tjenesten",
    "shiftCancelled": "Tjeneste aflyst",
    "cancelShiftHelpText": "Visningen af tjenesten vil være nedtonet. Du kan fortryde dette efterfølgende.",
    "annullCancelation": "Annuller aflysningen",
    "annullCancelationHelpText": "Visningen af tjenesten vil se normal ud igen.",
    "delete": "slet",
    "deleteShift": "Slet tjenesten",
    "deleteShiftHelpText": "Tjenesten vil blive slettet. Du kan ikke fortryde dette efterfølgende.",
    "deleteConfirmPreName": "Du er ved at slette ",
    "deleteConfirmPostName": "tjeneste. Er du sikker på, at du vil slette? Dette kan ikke fortrydes efterfølgende.",
    "confirmDeleteButton": "Bekræft sletning",
    "replace": "Erstat",
    "swap": "erstatte",
    "replaceShift": "Erstat tjenesten",
    "replaceShiftChooseText": "Vælg den medarbejder som skal erstatte tjenesten",
    "replaceShiftHelpText": "Tjenesten tildeles til en anden medarbejder. Du kan fortryde dette efterfølgende.",
    "replaceWith": "Erstat med ",
    "returnToScheduleShift": "Tilbage til tjenesteplan",
    "inaccessible": "Utilgængelig",
    "workingNow": "Hvem er på arbejde?",
    "workingLater": "Kommer senere",
    "noOneWorkingNow": "Der er ingen på arbejde lige nu...",
    "noOneComing": "Der kommer ingen senere...",
    "editScheduleShift": "Du kan nu redigere tjenesteplanen",
    "theScheduleShift": "Tjenesteplanen",
    "shiftFor": "tjenesten for",
    "cancelText": "aflyse",
    "cancelButton": "Aflys",
    "reactivateButton": "Genaktivér",
    "confirmCancelationButton": "Bekræft aflysning",
    "confirmReactivationButton": "Bekræft genaktivering",
    "editShiftButton": "Rediger tjeneste",
    "editNotAllowed": "Du skal være medarbejder for at redigere tjenesteplanen. Nulstil skærmen ved at gå til hovedskærmen, og prøv igen.",
    "notComing": "Kommer ikke",
    "reactivate": "genaktivere"
  },
  "calendar": {
    "moduleName": "Kalender"
  },
  "system": {
    "connectionError": "Fejl på forbindelsen",
    "connectionErrorText": "Systemet prøver automatisk at genetablere forbindelse...",
    "connectionErrorHelpText": "Systemet mangler grundlæggende oplysninger for at fungere. Du vil blive sendt til login om 10 sekunder",
    "testConnection": "Test forbindelse",
    "logOut": "Log ud",
    "menu": "Menu"
  },
  "travelPlan": {
    "moduleName": "Rejseplan"
  },
  "wayfinder": {
    "moduleName": "Find vej",
    "youAreHere": "Her er du",
    "groundFloor": "Stuen",
    "xFloor": "sal",
    "searchResidents": "Søg efter borgere - TRYK HER",
    "info": "Info",
    "toilet": "Toilet",
    "searchResult": "Søgeresultat:"
  },
  "weather": {
    "moduleName": "Vejret",
    "metersPerSecond": "m/s"
  },
  "profileSelect": {
    "header": "Hvem er du?",
    "description": "Vælg dig selv fra listen"
  },
  "profileDetails": {
    "header": "Logget ind som",
    "description": "Some description"
  },
  "feedback": {
    "stopRecording": "Stop med at optage",
    "addMessage": "Du kan beskrive fejlen du oplever i tekstfeltet herunder",
    "message": "Besked",
    "maxCharacters": "Maks 500 karakterer"
  },
  "emptyStates": {
    "ACTIVITIES": "Ingen aktiviteter",
    "EXTERNAL_ACTIVITIES": "Ingen eksterne aktiviteter",
    "GALLERY": "Ingen gallerier",
    "NEWS": "Ingen nyheder",
    "BOOKING": "Ingen bookinger",
    "MEETINGS": "Ingen møder",
    "MEAL_PLAN": "Ikke flere måltider i dag",
    "WORK_SCHEDULE": "Ingen tjenester at vise",
    "SIMPLE_WORK_SCHEDULE": "Ingen tjenester at vise",
    "LATER_WORK_SCHEDULE": "Ingen tjenester at vise",
    "JOURNEY_PLANNER": "Ingen afgange",
    "WEATHER": "Ingen vejrdata",
    "BOOKING_RESOURCES": "Ingen booking ressourcer",
    "OUR_HOME": "Intet at vise",
    "SLIDESHOW": "Ingen slideshows"
  },
  "emptyViews": {
    "Activities": "Ingen aktiviteter",
    "Galleries": "Ingen gallerier",
    "News": "Ingen nyheder",
    "Booking": "Ingen ressourcer",
    "Meetings": "Ingen møder",
    "MealPlan": "Ingen måltider",
    "WorkSchedule": "Ingen tjenester at vise"
  },
  "rrule": {
    "YEARLY": "Hvert år",
    "MONTHLY": "Hver måned",
    "WEEKLY": "Hver uge",
    "DAILY": "Hver dag",
    "HOURLY": "Hver time",
    "MINUTELY": "Hvert minut",
    "SECONDLY": "Hvert sekund"
  },
  "journeyPlanner": {
    "1Hour": "+1 time",
    "2Hours": "+2 timer",
    "30Minutes": "+30 minutter",
    "newTime": "Ny tid"
  },
  "meetings": {
    "addSuggestionPinTitle": "Skriv din kode for at tilføje et forslag til mødet",
    "optedOut": "Du er nu afmeldt mødet",
    "optOut": "Skriv din kode for at afmelde dig mødet",
    "signedUp": "Du er nu tilmeldt mødet",
    "signUp": "Skriv din kode for at tilmelde dig mødet"
  },
  "months": {
    "april": "april",
    "august": "august",
    "december": "december",
    "february": "februar",
    "january": "januar",
    "july": "juli",
    "june": "juni",
    "march": "marts",
    "may": "maj",
    "november": "november",
    "oktober": "oktober",
    "september": "september"
  },
  "workSchedule": {
    "cancel": {
      "confirmation": "Tjenesten er aflyst",
      "title": "Skriv din kode for at aflyse tjenesten for {name}"
    },
    "delete": {
      "confirmation": "Tjenesten er slettet",
      "title": "Skriv din kode for at slette tjenesten for {name}"
    },
    "reactivate": {
      "confirmation": "Tjenesten er genaktiveret",
      "title": "Skriv din kode for at genaktivere tjenesten for {name}"
    },
    "replace": {
      "confirmation": "Tjenesten er erstattet",
      "title": "Skriv din kode for at erstatte tjenesten for {name}"
    }
  }
}
